@let customer = customerDisplay(summary);
<section class="customer-section" [attr.aria-labelledby]="headingId">
  <h2 [id]="headingId">{{ 'dairyYieldScan.customer.title' | translate }}</h2>
  <dl class="customer-details">
    <div>
      <dt>{{ 'dairyYieldScan.fields.isExistingAgrifirmCustomer' | translate }}</dt>
      <dd data-test="customer-status">{{ customer.statusKey | translate }}</dd>
    </div>
    @if (customer.number !== null) {
      <div>
        <dt>{{ 'dairyYieldScan.fields.customerNumber' | translate }}</dt>
        <dd data-test="customer-number">{{ customer.number }}</dd>
      </div>
    }
    <div>
      <dt>{{ 'dairyYieldScan.fields.buysAgrifirmCompoundFeed' | translate }}</dt>
      <dd data-test="customer-feed">{{ customer.feedKey | translate }}</dd>
    </div>
  </dl>
</section>
